import React from 'react'
import { CommentDiv, CommentName, CommentDate, CommentText } from './ActivityStyledComponents'
import { Avatar } from 'rsuite'
import defaultAvatar from '../Styles/images/Avatar_placeholder.png'

const Comment = props => {
  const { name, text, date } = props
  return (
    <CommentDiv>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex' }}>
          <Avatar
            src={defaultAvatar}
            alt='UN'
            size='sm'
            style={{ marginRight: '16px' }}
          />
          <CommentName>{name}</CommentName>
        </div>
        <CommentDate>{date}</CommentDate>
      </div>
      <CommentText>{text}</CommentText>
    </CommentDiv>
  )
}

export default Comment
